import { createWidget } from '@alfa-bank/site-util-create-widget';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { setCursorPosition } from '@alfa-bank/site-form-helpers/src/meta/set-cursor-position';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { formatToRussian } from '@alfa-bank/site-helpers-common/browser/keyboard-switcher';
import { replacePointSpaceToSpace } from '@alfa-bank/site-form-helpers/text/replace-point-space-to-space';
import { everyWordToUpperCase } from '@alfa-bank/site-form-helpers/text/every-word-to-upper-case';
import { deleteExcessSpaceAndDash } from '@alfa-bank/site-form-helpers/text/delete-excess-space-and-dash';
import { BaseSelect as Select } from '@alfa-bank/site-form-utils/components/base-select';

import type { IDeps, TField } from './models';
import { Field as Component } from './field';

export const Field = createWidget<IDeps, TField>({
    Select,
    isSuccess,
    isError,
    getCaption,
    formatToRussian,
    replacePointSpaceToSpace,
    setCursorPosition,
    everyWordToUpperCase,
    deleteExcessSpaceAndDash,
})(Component);
